var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatreCapPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.565 18.9992H24V344.173H520.565V18.9992Z",
    fill: "#183AB2",
    stroke: "#3E68FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.064 89.4365L222.843 182.638C200.591 235.236 241.628 273.672 275.441 274.251C310.121 276.273 357.804 248.529 338.153 185.528C309.253 136.109 280.064 89.4365 280.064 89.4365ZM249.982 196.529L279.689 148.142C279.689 148.142 294.843 172.373 309.846 198.029C320.048 230.738 295.293 245.141 277.288 244.091C259.734 243.791 238.429 223.835 249.982 196.529Z",
    fill: "#3E68FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.465 167.484L259.188 200.51C251.303 219.149 265.845 232.769 277.827 232.974C290.116 233.691 307.013 223.859 300.049 201.534C289.809 184.023 279.465 167.484 279.465 167.484Z",
    fill: "#3E68FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatreCapPressed);
export default __webpack_public_path__ + "static/media/watre-cap-pressed.6d1adccc9b9b8f1f43f06d01a6e5cab6.svg";
export { ForwardRef as ReactComponent };